import React from "react";
import Settings from "@/components/SavingsSettings";

const SavingsSettings: React.FC = () => {
  return (
    <div>
      <Settings />
    </div>
  );
};

export default SavingsSettings;
